import { createAction } from "@reduxjs/toolkit";
import { IAuthResponse } from "../types/auth.types";

export const logoutSuccess = createAction("auth/logoutSuccess");
export const updateToken = createAction<IAuthResponse>("auth/updateToken");
export const showUnauthorizedModal = createAction<boolean>("userSlice/showUnauthorizedModal");